var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"infos"},[_vm._v(" 支付成功！ ")]),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.retrunFn()}}},[_vm._v("去往首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }